var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.wrapperTag,{tag:"component",attrs:{"href":_vm.link}},[_c(_vm.tag,{tag:"component",class:_vm.classes,style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }